var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('trend-card',{attrs:{"title":_vm.title},scopedSlots:_vm._u([{key:"radial",fn:function(){return [_c('radial-chart',{attrs:{"value":(_vm.stats*100).toFixed()}})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }